module.exports = __webpack_public_path__ + "static/media/FOOTER-LINE.77710286.PNG";